import Repository from './Repository'

export default {
  startClaim (dni) {
    return Repository.public().post(
      'claim/user/' + dni + '/start-claim'
    )
  },
  changePassword (dni) {
    return Repository.public().get(
      'claim/user/' + dni + '/change-password'
    )
  }
}
